const createState = () => ({
  loading: false,
  messages: [],
});

export default createState;
